import { render } from "./ProviderTraining.vue?vue&type=template&id=175c76d8"
import script from "./ProviderTraining.vue?vue&type=script&lang=js"
export * from "./ProviderTraining.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/gonapsacc-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__